import axios from "axios";

class DataFTEService1 {
  async getData() {
    return await axios.get(`data-fte/1`);
  }

  async updateDean(name: string) {
    return await axios.put(`data-fte/dean`, { name });
  }

  async updateDeputyDean(name: string) {
    return await axios.put(`data-fte/deputyDean`, { name });
  }
}
const DataFTEService = new DataFTEService1();
export default DataFTEService;
